import type { SVGProps } from 'react'
const SvgSecurityInprogress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.17188 6.57324V11.5225C6.17188 13.6445 6.77198 15.5726 7.97461 17.3086C9.17089 19.0354 10.6797 20.1855 12.5 20.7656C14.3203 20.1855 15.8291 19.0363 17.0254 17.3096C18.228 15.5736 18.8281 13.6454 18.8281 11.5234V6.57324L12.5 4.24023L6.17188 6.57324ZM12.5 8.14941C13.72 8.15014 14.7588 8.57272 15.6094 9.41602C16.4599 10.2593 16.8857 11.2893 16.8857 12.499C16.8857 13.7087 16.4599 14.739 15.6094 15.583H15.6084C14.7551 16.4238 13.717 16.8455 12.5 16.8477C11.2829 16.8498 10.2451 16.428 9.39258 15.583C8.53994 14.7376 8.11285 13.7074 8.11426 12.499C8.11572 11.2907 8.54184 10.2607 9.3916 9.41602C10.2415 8.57124 11.2799 8.1487 12.5 8.14941ZM12.1885 12.6279L14.2676 14.6904L14.71 14.251L12.8418 12.3984L12.8125 12.3691V9.53516H12.1885V12.6279ZM20.0996 11.5225C20.0996 13.9894 19.3815 16.2096 17.9453 18.1787C16.5099 20.1466 14.7038 21.4538 12.5283 22.0957L12.5 22.1045L12.4717 22.0957C10.2962 21.4552 8.49013 20.1486 7.05469 18.1807C5.61846 16.2115 4.90039 13.9908 4.90039 11.5225V5.70801L4.96484 5.68457L12.4648 2.90625L12.5 2.89355L12.5352 2.90625L20.0352 5.68457L20.0996 5.70801V11.5225Z"
      fill="#D0AF36"
      stroke="#D0AF36"
      strokeWidth="0.2"
    />
  </svg>
)

export default SvgSecurityInprogress
